import React from 'react';
import SpecificFieldsEdit from '../../components/SpecificFieldsEdit';
import FundingCalculatorMutation from './FundingCalculatorMutation';
import useFundingRates from '../../utils/hooks/useFundingRates';

const FundingCalculatorEdit = (props) => {
  const isTruck = props?.isTruck || false;
  const { fundingRates } = useFundingRates(isTruck);

  if (!fundingRates) return null;

  return (
    <SpecificFieldsEdit
      {...props}
      specificFields={[
        'nodeId',
        'id',
        'rate',
        'vehicleAge',
        'numOfPayments',
        'minYearsAfterPresent',
        'maxYearsAfterPresent',
        'balloonPercent',
        'updatingUserUid',
        'updatedAt'
      ]}
    >
      <FundingCalculatorMutation
        {...props}
        isNew={false}
        isTruck={isTruck}
        fundingRates={fundingRates}
      />
    </SpecificFieldsEdit>
  );
};

export default FundingCalculatorEdit;
